import React from 'react'
import { useContext } from 'react'
import { AuthContext } from '../../App'
import Button from '../../ui/Button/Button'
import ContactUsPopUp from '../ContactUs/ContactUsPopUp'
import './Top.sass'
import { NavLink } from 'react-router-dom'
import SocialLinks from './SocialLinks/SocialLinks'
import PhoneLinks from './PhoneLinks/PhoneLinks'
import EmailLink from './EmailLink/EmailLink'
import BusyHours from './BusyHours/BusyHours'
import Icon from '../../ui/Icon/Icon'
import PriceButton from '../PriceButton/PriceButton'

function Top() {
  const { showContactUs, setShowContactUs } = useContext(AuthContext)

  return (
    <>
      {showContactUs.show && <ContactUsPopUp />}
      <div className="Top">
        <div className="Top-Container DefaultContainer">
          {/* <SocialLinks /> */}
          <div className="Address">
            <Icon name="map-marker-alt" weight="solid" />
            <div>
              <span>м. Львів, вул. Грунтова 5</span>
              <br />
              <span>м. Львів, вул. Рахівська 19</span>
            </div>
          </div>
          <div className="Top-Contacts-Container">
            <PriceButton />
            <BusyHours />
            <PhoneLinks />
          </div>
        </div>
      </div>
    </>
  )
}

export default Top
